import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";
import { formatDate } from "@/lib/comicUtils";

interface ComicCardProps {
  comic: Comic;
  showRank?: number;
}

export default function ComicCard({ comic, showRank }: ComicCardProps) {
  const latest = comic.chapters[comic.chapters.length - 1];

  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[5/7] w-full overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 漫画在线阅读`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/95 px-2 py-0.5 text-xs text-background-50">
          {comic.status}
        </span>
        {typeof showRank === "number" && (
          <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-md bg-foreground-950/70 text-xs font-medium text-background-50">
            {showRank}
          </span>
        )}
        <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
          {comic.region}
        </span>
      </div>
      <div className="p-3">
        <h3 className="line-clamp-1 text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <div className="mt-2 flex flex-wrap gap-1">
          {comic.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="rounded bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-800"
            >
              {g}
            </span>
          ))}
        </div>
        <p className="mt-2 line-clamp-1 text-xs text-foreground-500">
          {latest ? latest.name : "暂无章节"}
        </p>
        <p className="mt-1 text-xs text-foreground-400">
          更新于 {formatDate(comic.updatedAt)}
        </p>
      </div>
    </Link>
  );
}